import { queryKeys } from '@/lib/query-keys';
import { orgMembersClient } from '@/lib/api/ts-rest';
import type { OrganizationRole } from '@octave/contracts';
import { createLogger } from '@/lib/logger';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const log = createLogger('useInviteUser');

export function useInviteUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      organizationId,
      email,
      role,
    }: {
      organizationId: string;
      email: string;
      role: OrganizationRole;
    }) => {
      const res = await orgMembersClient.sendInvitation({
        params: { organizationId },
        body: { email, role },
      });
      if (res.status !== 201) throw new Error('Failed to send invitation');
      return res.body;
    },
    onSettled: () => {
      // Invalidate both organization and pending invitations queries
      queryClient.invalidateQueries({ queryKey: queryKeys.organizations.detail() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.pendingInvitations(),
      });
    },
    onError: (error) => {
      toast.error("Erreur lors de l'envoi de l'invitation");
      log.error("Erreur lors de l'envoi de l'invitation", error);
    },
  });
}
